// apps/admin/src/pages/settings/SecurityCenterPage.tsx
//
// Phase 1 Wave 12 Task 104 — Admin Security Center thin wrapper.
// Wraps the shared SecurityCenterPage in SettingsLayout with portal="admin".

import {
  SecurityCenterPage as SharedSecurityCenter,
  SettingsLayout,
} from '@printway/ui';

export function SecurityCenterPage(): JSX.Element {
  return (
    <SettingsLayout portal="admin" activeTab="security">
      <SharedSecurityCenter />
    </SettingsLayout>
  );
}

export default SecurityCenterPage;
